export default {
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_home: 'Home',
  nav_shopping_guide: 'Shopping Guide',
  nav_reviews: 'Reviews',
  nav_shipping: 'Shipping',
  nav_coupons: 'Coupons',
  nav_guides: 'Guides',
  nav_safety: 'Safety',
  nav_warehouse: 'Warehouse',
  nav_blog: 'Blog',
  nav_about: 'About',
  nav_contact: 'Contact',
  nav_faq: 'FAQ',
  hero_title: 'CSSBuy Spreadsheet 2026: Find Products, Links & Guides',
  hero_subtitle: 'Explore an independent CSSBuy Spreadsheet resource with product research, category guides, QC explanations, shipping information, and practical buying tips.',
  hero_cta_primary: 'Explore CSSBuy Spreadsheet',
  hero_cta_secondary: 'View Guides',
  trust_badge: 'Independent resource · Updated content · Practical guides · PT / EN / DE',
  what_is_title: 'What is a CSSBuy Spreadsheet?',
  what_is_p1: 'A CSSBuy Spreadsheet is an organized way to collect products, links, categories, and useful information to make research easier. It helps you find information faster, but every item should be verified before purchasing.',
  what_is_p2: 'A spreadsheet does not guarantee quality, price, stock, availability, or delivery. Always confirm current information before finalizing any order.',
  what_is_cta: 'View CSSBuy Spreadsheet',
  how_it_works_title: 'How to Use the CSSBuy Spreadsheet',
  step_1: 'Choose a category',
  step_2: 'Find a product or link',
  step_3: 'Check price and info',
  step_4: 'Verify QC, size and details',
  step_5: 'Compare alternatives',
  step_6: 'Confirm current conditions',
  step_7: 'Continue on the main site',
  how_cta: 'Get Started Now',
  categories_title: 'Explore Categories',
  categories_subtitle: 'Browse product categories and find what you need',
  guides_title: 'Most Popular CSSBuy Guides',
  guides_subtitle: 'Detailed guides to help you navigate CSSBuy safely',
  comparison_title: 'CSSBuy Spreadsheet vs Traditional Research',
  comparison_feature: 'Feature',
  comparison_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_traditional: 'Traditional Research',
  comparison_org: 'Organization by category',
  comparison_links: 'Links gathered',
  comparison_guides: 'Specific guides',
  comparison_compare: 'Comparison',
  comparison_intent: 'Intent-based research',
  comparison_yes: 'Yes',
  comparison_no: 'No',
  comparison_limited: 'Limited',
  comparison_easy: 'Easy',
  comparison_manual: 'Manual',
  safety_title: 'Research with More Safety',
  safety_tip_1: 'Verify the domain and link before accessing',
  safety_tip_2: 'Confirm product information',
  safety_tip_3: 'Check size and options',
  safety_tip_4: 'Read QC information',
  safety_tip_5: 'Verify shipping costs',
  safety_tip_6: 'Confirm current coupons',
  safety_tip_7: 'Never share passwords',
  safety_tip_8: 'Never send financial data to unknown sites',
  safety_cta: 'Read Safety Guide',
  articles_title: 'Latest CSSBuy Guides',
  articles_subtitle: 'Detailed articles and guides for safe shopping',
  read_guide: 'Read Guide',
  reading_time: 'min read',
  updated: 'Updated',
  faq_title: 'Frequently Asked Questions',
  faq_subtitle: 'Common questions about CSSBuy Spreadsheet',
  final_cta_title: 'Ready to start?',
  final_cta_subtitle: 'Explore the CSSBuy Spreadsheet and continue your research on our main website.',
  final_cta_button: 'Explore CSSBuy Spreadsheet',
  main_cta_button: 'Buy It Now',
  footer_resources: 'Resources',
  footer_company: 'Company',
  footer_disclaimer: 'Independent informational resource. Not the official CSSBuy website. External information may change.',
  lang_pt: 'PT',
  lang_en: 'EN',
  lang_de: 'DE',
  editorial_policy: 'Editorial Policy',
  disclaimer: 'Disclaimer',
  privacy: 'Privacy Policy',
  about_us: 'About Us',
  article_author: 'Editorial Team',
  article_related: 'Related Articles',
  article_toc: 'Table of Contents',
  article_quick_answer: 'Quick Answer',
  article_pros: 'Pros',
  article_cons: 'Cons',
  article_checklist: 'Checklist',
  breadcrumb_home: 'Home',
  breadcrumb_guides: 'Guides',
  category_select: 'Select a Category',
  category_dropdown_label: 'Browse Categories',
  home_seo_title: 'CSSBuy Spreadsheet 2026: Links, Guides & Products',
  home_seo_description: 'Explore the CSSBuy Spreadsheet 2026 with links, categories, guides, QC, shipping, coupons and practical information to research products more safely.',
  home_seo_keywords: 'CSSBuy Spreadsheet, CSSBuy links, CSSBuy guide, CSSBuy QC, CSSBuy shipping, CSSBuy coupon',
  back_to_home: 'Back to Home',
  learn_more: 'Learn More',
  view_all: 'View All',
  search: 'Search',
  minutes_read: 'min read',
  share: 'Share',
  copy_link: 'Copy Link',
  copied: 'Copied!',
};